<div class="fo-user border-bottom">
<div class="d-flex">
  <div class="fo-tooltip-wrap">
    <div class="fo-avatar fo-cursor" [routerLink]="['/', userState?.user?.handle]">
      <img [src]="userState?.user?.photoURL || './assets/images/profile.jpg'">
    </div>
  </div>
  <div>
    <span class="fo-name mr-1 cu-truncate" [routerLink]="['/', userState?.user?.handle]">{{userState?.user?.name}}</span>
    <span class="fo-username text-success fo-cursor fo-tooltip-wrap cu-truncate">
      @{{userState?.user?.handle}}
    </span>
    <p class="bio-truncate pr-1 cu-desktop">{{userState?.user?.bio}}</p>
  </div>
  <div class="ml-auto fo-actions d-flex align-items-start">
    <div *ngIf="currentUser && currentUser?.ID !== userState?.user?.ID">
      <button *ngIf="!userState?.user?.ifollow" class="fo-follow" mat-raised-button (click)="followUserAction()">
        <span>Follow</span>
      </button>
      <button *ngIf="userState?.user?.ifollow" class="fo-following" mat-raised-button (click)="unFollowUserAction()">
        <span>Following</span>
      </button>
    </div>

    <button mat-icon-button class="mr-1" [matMenuTriggerFor]="foActions"
      *ngIf="currentUser && currentUser.ID !== userState?.user?.ID">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #foActions="matMenu">
      <button mat-menu-item routerLink="/dm/new">
        <mat-icon color="primary">mail</mat-icon>
        <span class="text-success">Message</span>
      </button>
      <button mat-menu-item>
        <mat-icon color="accent">cancel</mat-icon>
        <span class="text-danger">Block</span>
      </button>
      <button mat-menu-item>
        <mat-icon color="warn">report_problem</mat-icon>
        <span class="text-danger">Report</span>
      </button>
    </mat-menu>
  </div>
</div>
<p class="pr-1 cu-mobile">{{userState?.user?.bio}}</p>
</div>